module.exports = "/lucky-balls/img/weager/Tab_normal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Tab_normal.png
// module id = 1173
// module chunks = 0